import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { LogOut, User, Moon, Sun, Menu, Download } from 'lucide-react';
import { useUserData } from '../../hooks/useUserData';
import { useTheme } from '../../contexts/ThemeContext';
import { usePWA } from '../../contexts/PWAContext';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  onMenuClick: () => void;
  isSidebarOpen: boolean;
}

export const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { user, signOut } = useAuth();
  const { userData } = useUserData();
  const { isDarkMode, toggleDarkMode } = useTheme();
  const { canInstall, isStandalone, installApp } = usePWA();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Fehler beim Abmelden:', error);
    }
  };

  return (
    <header className="sticky top-0 z-20 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Left section */}
          <div className="flex items-center">
            <button
              onClick={onMenuClick}
              className="lg:hidden -ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            >
              <span className="sr-only">Menü öffnen</span>
              <Menu className="h-6 w-6" />
            </button>
            
            <h1 className="ml-2 text-xl font-semibold text-gray-900 dark:text-white lg:hidden">
              Dashboard
            </h1>
          </div>

          {/* Right section */}
          <div className="flex items-center gap-2 sm:gap-4">
            {canInstall && !isStandalone && (
              <button
                onClick={installApp}
                className="block sm:hidden px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <Download className="h-5 w-5 sm:mr-2" />
                <span className="hidden sm:inline">App installieren</span>
              </button>
            )}

            <button
              onClick={toggleDarkMode}
              className="p-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              title={isDarkMode ? 'Zum hellen Design wechseln' : 'Zum dunklen Design wechseln'}
            >
              {isDarkMode ? (
                <Sun className="h-5 w-5" />
              ) : (
                <Moon className="h-5 w-5" />
              )}
            </button>

{/* Externer Link-Button */}
<a
  href="https://www.paypal.com/donate/?hosted_button_id=JKX4EXHPXZETW"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-3 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
  title="Trinkgeld geben"
>
  <span className="sm:hidden">$</span> {/* Zeigt nur das Icon auf Mobilgeräten */}
  <span className="hidden sm:inline">Trinkgeld</span> {/* Zeigt den Text nur auf größeren Bildschirmen */}
</a>

            
            <div className="hidden sm:flex items-center">
              <User className="h-5 w-5 text-gray-500 dark:text-gray-400" />
              <span className="ml-2 text-sm font-medium text-gray-700 dark:text-gray-300 truncate max-w-[150px]">
                {userData?.name || user?.email}
              </span>
            </div>
            
            <button
              onClick={handleSignOut}
              className="inline-flex items-center text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              title="Abmelden"
            >
              <LogOut className="h-5 w-5" />
              <span className="ml-2 text-sm hidden sm:inline">Abmelden</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
